// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1_RpP","selected":"Chip_selected__FpsgU"};